import { useState, useEffect } from 'react';
import { useUserData } from "@/components/navigation/hooks/useUserData";
import { User } from "@/app/types/User";
import { isOnboarded } from "@/utils/onboarding";

interface OnboardingState {
  isLoading: boolean;
  isOnboarded: boolean;
  user: User | null;
  showHeadsUp: boolean;
}

export const useOnboardingState = (): OnboardingState => {
  const [mounted, setMounted] = useState(false);
  const { 
    userDetails, 
    isUserDetailsLoading, 
    team, 
    teamPreferences, 
    isLoadingTeamPreferences,
    effectiveProducts,
    effectiveBuyingPersona 
  } = useUserData();

  useEffect(() => {
    setMounted(true);
  }, []);

  const isLoading = isUserDetailsLoading || isLoadingTeamPreferences;

  const userIsOnboarded = mounted && !isLoading && userDetails && isOnboarded({
    userDetails,
    team,
    teamPreferences: teamPreferences ?? null,
    effectiveProducts,
    effectiveBuyingPersona
  });

  const showHeadsUp = userIsOnboarded && !userDetails?.headsUp;

  return { 
    isLoading, 
    isOnboarded: userIsOnboarded || false, 
    user: userDetails,
    showHeadsUp: showHeadsUp || false
  };
}; 